import { RequestService } from '../../../../../common/services/RequestService';
import { DADATA_SUGGEST_GET } from '../../../../../common/constants/systemUrls';

export const dadataRequest = payload => {
  return RequestService.get(DADATA_SUGGEST_GET + payload);
};
